import type { RumEvent, RumEventDomainContext } from '@datadog/browser-rum';

const errorIgnoreListPartial = [
  'pinterest',
  'gtag',
  'doubleclick',
  'tealium',
  'web.aips-sol',
  'web.sol-data',
  'asia.creativecdn',
  'google-analytics',
  'hotjar',
  'snapchat',
  'googlesyndication',
  'message":"Failed to fetch',
];

const errorIgnoreListExact = [
  'console error:',
  '',
  'Error: Failed to fetch',
  'Failed to fetch',
  'Network Error',
  "console error: Error: Timeout when executing 'fetch'",
  'NetworkError when attempting to fetch resource.',
];

export const shouldSendEventToDatadog = (
  event: RumEvent,
  context: RumEventDomainContext,
) => {
  if (event.type !== 'error') {
    return true;
  }

  for (const partialError of errorIgnoreListPartial) {
    if (event?.error.message.toLowerCase().includes(partialError)) {
      return false;
    }
  }

  for (const exactError of errorIgnoreListExact) {
    if (event?.error.message.trim() === exactError.trim()) {
      return false;
    }
  }

  // capture any additional error context in event for logging
  if ('error' in context) {
    if (!event.context) {
      event.context = {};
    }
    const errorContext = context.error as Record<string, unknown>;
    for (const key in Object.keys(errorContext)) {
      if (!Boolean(event.context[key])) {
        event.context[key] = errorContext[key];
      }
    }
  }

  return true;
};
